import type { z } from 'zod';
import { OrderStatus } from 'store/orders';
import { ContentLanguage, Currency } from 'types/general';
import { RedeemMethods } from 'store/vouchers';
import type { adminOrdersFiltersSchema } from './admin-orders.schemas';

export const paymentTypes = ['company', 'mixed', 'personal'] as const;
export type PaymentType = (typeof paymentTypes)[number];
export interface AdminOrder {
  id: string;
  createdAt: string;
  expenseDate: string | null;
  status: OrderStatus;
  orderNr: string;
  price: number;
  currency: Currency;
  redeemMethods: RedeemMethods;
  couponFileId: string;
  commentForEmployee: string;
  commentForAdmin: string;
  purchasePrice?: number;
  paymentType: PaymentType;
  admin: {
    id: string;
    fullName: string;
  } | null;
  shopItem: {
    id: string;
    name: string;
    sku: string;
    additionalInfo: string;
    countries: string[];
    price: number;
    priceDescription: string;
    vatRate: number;
    vatAmount: number;
    pricePreVat: number;
  };
  company: {
    id: string;
    name: string;
    parentCompany: {
      id: string;
      name: string;
    } | null;
    code: string;
    contacts: Array<{
      id: string;
      fullName: string;
      email: string;
      phone: string;
    }>;
  };
  employee: {
    id: string;
    language: Uppercase<ContentLanguage>;
  };
  employeePaymentAmount: number;
  shopUser: {
    id: string;
    fullName: string;
    email: string;
    phoneNumber: string;
    employeeId: string;
    transactionId: string;
  } | null;
  accessHistory: string[];
  voucher:
    | ({
        id: string;
        sequence: number;
        purchasePrice: number;
        purchaseReference: string;
      } & RedeemMethods)
    | null;
  isAutomatedVoucher: boolean;
}

export type AdminOrdersFilters = z.infer<typeof adminOrdersFiltersSchema>;

export type SearchFilterName =
  | 'parentCompanyName'
  | 'companyName'
  | 'itemSku'
  | 'itemName';
